import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, type QueryKeyParam } from '../../../query/types';

const consumerCheckoutKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'checkout'] as const;
  return createQueryKey({
    all: key,
    id: (checkoutId: QueryKeyParam) =>
      createQueryKey({
        all: [...key, checkoutId] as const,
        detail: [...key, checkoutId, 'detail'] as const,
      }),
    detail: [...key, 'detail'] as const,
  });
};

export { consumerCheckoutKeys };
